import { useConfig } from '@app/contexts/config';
import Step1 from '@app/pages/auth/Login/Step1';
import Step2 from '@app/pages/auth/Login/Step2';
import Step3 from '@app/pages/auth/Login/Step3';
import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styles from './Login.module.scss';

export type LoginStep = 1 | 2 | 3;

export interface LoginContacts {
  email: string;
  phone: string | null;
}

export type SendTo = 'phone' | 'email' | null;

const Login = (): JSX.Element => {
  const [step, setStep] = useState<LoginStep>(1);
  const [contacts, setContacts] = useState<LoginContacts>({ email: '', phone: null });
  const [sendTo, setSendTo] = useState<SendTo>(null);
  const { t } = useTranslation();
  const { supportEmail } = useConfig();

  return (
    <>
      <section>
        <Helmet>
          <title>Login</title>
        </Helmet>

        {step === 1 && <Step1 setStep={setStep} setContacts={setContacts} setSendTo={setSendTo} />}

        {step === 2 && (
          <Step2
            contacts={contacts}
            setContacts={setContacts}
            setStep={setStep}
            sendTo={sendTo}
            setSendTo={setSendTo}
          />
        )}

        {step === 3 && (
          <Step3
            contacts={contacts}
            setStep={setStep}
            sendTo={sendTo}
            setSendTo={setSendTo}
            setContacts={setContacts}
          />
        )}
      </section>

      {step === 1 && (
        <Typography className={styles.Support}>
          {t('Can’t login? For support, please email')} <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </Typography>
      )}
    </>
  );
};

export default Login;
